{
    "Property": [
        "5207"
    ],
    "APD": [
        "5261"
    ],
    "Casualty": [
        "CCCC"
    ]
}